import { useEffect } from "react"
import { initCloudflareWebAnalytics } from "../lib/analytics"

const CloudflareAnalytics = () => {
  useEffect(() => {
    initCloudflareWebAnalytics()
  }, [])

  return null
}

export default CloudflareAnalytics
